import React from 'react';
import { RemoveScroll } from 'react-remove-scroll';
// import 'rc-drawer/assets/index.css';
// 直接用模块中的 css 样式会错乱
import './Drawer.css';
import './Drawer.scss';
import Drawer from 'rc-drawer';
import { eventEmitter } from '@/utils/chatuiEvents';
import closeImage from '@/assets/img/drawer_close.svg';

export interface DrawerFuncProps {
  style?: any;
  destroyOnClose?: boolean;
  show?: boolean;
  children: React.ReactChild;
  onClose?: () => void;
  afterClose?: () => void;
  hasCloseIcon?: boolean;
  width?: string;
  height?: string;
}
interface State {
  shouldUnmount: boolean;
}
export default class extends React.Component<DrawerFuncProps, State> {
  flag = false;
  state = { shouldUnmount: false };
  timer!: number;
  cancel!: Function;

  componentDidUpdate(prevProps: any) {
    // unmount when invisible
    if (!this.props.show && prevProps.show) {
      this.flag = true;
    }

    // when visible, mount
    if (this.state.shouldUnmount && this.props.show && !prevProps.show) {
      this.setState({ shouldUnmount: false });
    }
  }

  waitAnimationFinishThenUnmount = () => {
    if (this.flag) {
      this.setState({ shouldUnmount: true }, () => {
        this.flag = false;
      });
    }
  };

  render() {
    const {
      onClose,
      show,
      children,
      destroyOnClose,
      hasCloseIcon = true,
      width = '100vw',
      height = '80vh',
    } = this.props;
    const { shouldUnmount } = this.state;

    if (destroyOnClose && shouldUnmount) {
      return null;
    }

    //  Drawer 这里也需要 modal 全局 变量记录一下 然后统一在 android 返回键 里关闭
    eventEmitter?.emit('setGlobalModalConfigVisible', show);
    eventEmitter?.emit('setGlobalModalConfigHide', () => {
      onClose && onClose();
    });

    return (
      <Drawer
        afterVisibleChange={this.waitAnimationFinishThenUnmount}
        open={show}
        handler={false}
        placement="bottom"
        onClose={() => {
          onClose && onClose();
        }}
        level={null}
        width={width}
        height={height}
      >
        {hasCloseIcon ? (
          <div
            className="close-icon"
            onClick={() => {
              onClose && onClose();
            }}
          >
            <img src={closeImage} />
          </div>
        ) : null}
        <RemoveScroll>{children}</RemoveScroll>
      </Drawer>
    );
  }
}
